import ColoredChipsCell from "@common/components/coloredChipsCell/ColoredChipsCell";
import React from "react";
import { ITableHeader } from "@dotlegal/dotlegal-ui-components";
import { TableCell } from "@mui/material";
import { SelectableAssignee } from "../SelectableAssignee.types";
import { getAssigneeTypeName } from "../SelectableAssignee.utils";

// The recipient columns are shared by the assignee selector and the send confirmation dialog, so a column added
// here shows up in both instead of only in whichever list happened to be edited.
export function getSelectableAssigneeHeaders(translateString: (key: string) => string) {
    const headers = Array<ITableHeader<SelectableAssignee>>();
    headers.push({ property: "name", text: translateString("recipient"), align: "left", showOnMobile: true });
    headers.push({ property: "email", text: translateString("email"), align: "left", showOnMobile: true });
    headers.push({ property: "assigneeType", text: translateString("recipientType"), align: "left", showOnMobile: true });
    headers.push({ property: "legalEntityName", text: translateString("sourceEntity"), align: "left", showOnMobile: true });
    headers.push({ property: "businessAreas", text: translateString("businessAreas"), align: "left", showOnMobile: true });

    return headers;
}

export interface ISelectableAssigneeCellsProps {
    row: SelectableAssignee;
    translateString: (key: string) => string;
}

export function SelectableAssigneeCells({ row, translateString }: ISelectableAssigneeCellsProps) {
    return (
        <React.Fragment>
            <TableCell>{row.name}</TableCell>
            <TableCell>{row.email}</TableCell>
            <TableCell>{getAssigneeTypeName(row.assigneeType, translateString)}</TableCell>
            <TableCell>{row.legalEntityName ?? ""}</TableCell>
            <TableCell>
                <ColoredChipsCell items={row.businessAreas} />
            </TableCell>
        </React.Fragment>
    );
}
